import { render, staticRenderFns } from "./video-flv.vue?vue&type=template&id=b5b7a79c&scoped=true"
import script from "./video-flv.vue?vue&type=script&lang=js"
export * from "./video-flv.vue?vue&type=script&lang=js"
import style0 from "./video-flv.vue?vue&type=style&index=0&id=b5b7a79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b7a79c",
  null
  
)

export default component.exports